import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// ACESSO-01 (L8b): criar, editar e apagar etiquetas (`labels#create`, `#update`, `#destroy`). Ler é de todo membro.
const ESCOPOS_DAS_ETIQUETAS = ['labels:manage'];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'labels_wrapper',
          meta: {
            permissions: ['administrator', 'label_manage'],
            escopos: ESCOPOS_DAS_ETIQUETAS,
          },
          redirect: to => {
            return { name: 'labels_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'labels_list',
          meta: {
            featureFlag: FEATURE_FLAGS.LABELS,
            permissions: ['administrator', 'label_manage'],
            escopos: ESCOPOS_DAS_ETIQUETAS,
          },
          component: Index,
        },
      ],
    },
  ],
};
